// Free daily allowance shared by HTML/CSS and external-agent exports.
// Figma export is paid-only and does not draw from this allowance.
export const NUMBER_OF_FREE_FIGMA_EXPORTS = 3;

// Plus tier (individual and team)
export const PLUS_MONTHLY_BASE = 100;
export const PLUS_DAILY_REFILL = 10;

// Pro tier (individual and team) — was previously unlimited.
export const PRO_MONTHLY_BASE = 600;
export const PRO_DAILY_REFILL = 10;

// Intercom help article explaining the Pro credit limits. Opened from the
// announcement modal's "Learn more" button. Update if the article changes.
export const PRO_LIMITS_HELP_ARTICLE_ID = 15973979;
